// extracted by mini-css-extract-plugin
module.exports = {"sponsor-group-title":"SponsorsSectionTemplateOne_sponsor-group-title__1M5cz","sponsor-group-col":"SponsorsSectionTemplateOne_sponsor-group-col__2damN"};